export interface CustomerCreditNotes {
  id: string;
  creditNoteNo: number;
  creditNoteDate: Date;
  creditNotePrice: number;
  creditNoteGoodsValue: number;
  creditNoteDeliveryValue: number;
  creditNoteExtraValue: number;
  creditNoteNettValue: number;
  creditNoteTaxValue: number;
  creditNoteTotalValue: number;
  exchangeRate: number;
  sterlingTotal: number;
  currencyCode: string;
  currencySymbol: string;
  creditInvoiceNo: number;
  deliveryAddress: string;
}
